// @ts-nocheck
// -----------------------------
// CONFIGURACIÓN LOCAL (fácil de modificar)
const PRESCRIPTION_STEP_CONFIG = {
  SHOP_DOMAIN: 'gf7q0f-ma.myshopify.com',
  // Prescripción no necesita tags ni productos, pero definimos defaults
  PRODUCTS_LIMIT: 0,
  PREFERRED_ORDER: [],
  MULTI_SELECT: false,
  USE_BASIC_FALLBACK: false,
  // Mostrar imagenes en las cartas de opción si están disponibles (no aplicable en prescription pero mantenemos la flag)
  MOSTRAR_IMAGENES_PRODUCTO: false
};
// -----------------------------

/**
 * Step específico: Prescripción
 */
class PrescriptionStep extends LensConfiguratorStep {
  constructor(configurator, options = {}) {
    super(configurator, {
      ...options,
      stepKey: 'prescription',
      title: 'Prescripción',
      description: 'Ingresa los valores de tu prescripción'
    });
  }

  /**
   * Abrir el overlay inline con la imagen de la prescripción
   */
  openPrescriptionOverlay(src) {
    try {
      if (!src) return;
      // Intentar encontrar un overlay ya presente (creado por injectInline)
      const overlay = document.querySelector('.prescription-photo-overlay');
      if (overlay) {
        const img = overlay.querySelector('.prescription-photo-overlay__content img');
        if (img) img.src = src;
        overlay.style.display = 'flex';
        try { document.body.style.overflow = 'hidden'; } catch(e){}
        return;
      }

      // Si no existe overlay, crear uno temporal y mostrarlo
      const temp = document.createElement('div');
      temp.className = 'prescription-photo-overlay';
      temp.style.cssText = 'position: fixed; inset:0; display:flex; align-items:center; justify-content:center; background:rgba(0,0,0,0.6); z-index:9999;';
      temp.innerHTML = `<div style="position:relative; max-width:92%; max-height:92%; background:#fff; padding:12px; border-radius:8px;"><button type="button" style="position:absolute; top:8px; right:8px; background:transparent; border:none; font-size:20px;">✕</button><div style="max-height:calc(90vh - 60px); overflow:auto; display:flex; align-items:center; justify-content:center;"><img src="${src}" style="max-width:100%; max-height:80vh; display:block;"></div></div>`;
      temp.addEventListener('click', (ev) => { if (ev.target === temp) temp.remove(); });
      temp.querySelector('button').addEventListener('click', () => temp.remove());
      document.body.appendChild(temp);
      try { document.body.style.overflow = 'hidden'; } catch(e){}
      // Auto-remover scroll lock al cerrar
      const observer = new MutationObserver(() => { if (!document.body.contains(temp)) { try{ document.body.style.overflow = ''; }catch(e){} observer.disconnect(); } });
      observer.observe(document.body, { childList: true });
    } catch (e) {
      console.warn('openPrescriptionOverlay failed', e);
    }
  }

  static get STEP_CONFIG() {
    return PRESCRIPTION_STEP_CONFIG;
  }

  render() {
    // Renderizar las opciones de prescripción (si existe el bloque prebuilt, no se inserta automáticamente)
    const container = document.getElementById('prescription-options');
    if (!container) return;

    // 🔄 Intentar recuperar prescripciones guardadas automáticamente
    this.tryRestorePreviousPrescription();

    // Si existe un bloque preconstruido en el DOM (por id o por clase), extraerlo del DOM y guardar su HTML
    const prebuilt = document.getElementById('prescription-inputs') || document.querySelector('.prescription-inputs');
    if (prebuilt) {
      try {
        const html = (prebuilt.innerHTML || '').trim();
        // Solo usamos HTML preconstruido si contiene algo util
        if (html.length > 0) {
          this._prebuiltPrescriptionHTML = html;
        }
        // remover del DOM para que no se muestre por defecto
        if (prebuilt.parentNode) prebuilt.parentNode.removeChild(prebuilt);
      } catch (e) {
        // fallback: intentar ocultarlo si no se puede remover
        try { prebuilt.style.display = 'none'; } catch (e2) {}
      }
    }

    container.innerHTML = '';

    // Soporta traducciones: si existe `window.themeTranslations.prescription.options` se usan
    const _t = (keyPath, fallback) => {
      try {
        const parts = keyPath.split('.');
        let cur = window.themeTranslations;
        for (const p of parts) {
          if (!cur) return fallback;
          cur = cur[p];
        }
        return typeof cur === 'string' ? cur : (cur || fallback);
      } catch (e) {
        return fallback;
      }
    };

    const options = [
      /*{
        key: 'manual',
        name: _t('prescription.options.manual.name', 'Inserto mi graduación ahora'),
        description: _t('prescription.options.manual.description', 'Introduce la prescripción manualmente.')
      },*/
      {
        key: 'photo',
        name: _t('prescription.options.photo.name', 'Adjunto mi gradución (foto)'),
        description: _t('prescription.options.photo.description', 'Adjunta una foto de tu prescripción.')
      },
      {
        key: 'existing',
        name: _t('prescription.options.existing.name', 'Ya soy cliente'),
        description: _t('prescription.options.existing.description', 'Comprobaremos si ya tenemos tu graduación.')
      },
      {
        key: 'email',
        name: _t('prescription.options.email.name', 'La mando luego'),
        description: _t('prescription.options.email.description', 'Te damos instrucciones para enviarla por correo.')
      }
    ];

    const grid = document.createElement('div');
    grid.className = 'options-grid prescription-options-group';

    options.forEach(opt => {
      // Small inline SVGs for icons
      const icons = {
        manual: `<svg viewBox="0 0 24 24" fill="none" role="img" aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg"><path d="M3 7v10a2 2 0 0 0 2 2h14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 3H7a2 2 0 0 0-2 2v2h14V5a2 2 0 0 0-2-2z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        photo: `<svg viewBox="0 0 24 24" fill="none" role="img" aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg"><path d="M3 7v10a2 2 0 0 0 2 2h14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 11a3 3 0 1 0-3 3 3 3 0 0 0 3-3z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        existing: `<svg viewBox="0 0 24 24" fill="none" role="img" aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        email: `<svg viewBox="0 0 24 24" fill="none" role="img" aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg"><path d="M3 8l9 6 9-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 19H3V8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`
      };

      // Reutilizar createOptionCard para mantener exactamente el mismo aspecto
      const card = this.createOptionCard(opt.key, {
        name: opt.name,
        description: opt.description,
        price: 0,
        icon: icons[opt.key] || ''
      }, 'prescription', false);

      // Asegurar que el card responde al click para mostrar la opción
      card.addEventListener('click', () => this.showPrescriptionOption(opt.key));
      // Accesibilidad: permitir activación por teclado (Enter / Space)
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          this.showPrescriptionOption(opt.key);
        }
      });
      // Si la opción es 'photo' evitamos el auto-advance del handler global
      if (opt.key === 'photo') {
        card.dataset.preventAutoAdvance = 'true';
      }

      // Si ya existe una prescripción de tipo foto, añadimos botón 'Ver imagen' y miniatura dentro de la tarjeta
      if (opt.key === 'photo') {
        try {
          const existingPres = this.configurator && this.configurator.configuration ? this.configurator.configuration.prescription : null;
          const controls = document.createElement('div');
          controls.className = 'option-photo-controls';
          controls.style.cssText = 'margin-top:8px; display:flex; gap:8px; align-items:center;';

          const thumb = document.createElement('img');
          thumb.className = 'option-photo-thumb';
          thumb.style.cssText = 'width:44px; height:44px; object-fit:cover; border-radius:6px; display:none; box-shadow:0 2px 8px rgba(0,0,0,0.08);';
          controls.appendChild(thumb);

          const viewBtnCard = document.createElement('button');
          viewBtnCard.type = 'button';
          viewBtnCard.className = 'nav-btn secondary option-photo-view-btn';
          viewBtnCard.innerHTML = '<span>Ver imagen</span>';
          viewBtnCard.style.display = 'none';
          controls.appendChild(viewBtnCard);
          
          const changeBtnCard = document.createElement('button');
          changeBtnCard.type = 'button';
          changeBtnCard.className = 'nav-btn secondary option-photo-change-btn';
          changeBtnCard.innerHTML = '<span>Cambiar imagen</span>';
          changeBtnCard.style.display = 'none';
          controls.appendChild(changeBtnCard);

          // Insert controls after description or header
          const descEl = card.querySelector('.option-description') || card.querySelector('.option-header');
          if (descEl && descEl.parentNode) {
            descEl.parentNode.insertBefore(controls, descEl.nextSibling);
          } else {
            card.appendChild(controls);
          }

          const updateControls = (prescription) => {
            const descEl = card.querySelector('.option-description');
            if (prescription && prescription.method === 'photo' && (prescription.url || prescription.filename)) {
              const src = prescription.url || (prescription.cloudinary && prescription.cloudinary.secure_url) || null;
              // Mark card as selected visually
              try { card.classList.add('selected'); card.setAttribute('aria-selected', 'true'); } catch(e){}
              // Replace description to indicate there's already an image
              if (descEl) {
                const filename = prescription.filename || (prescription.cloudinary && prescription.cloudinary.public_id) || 'Prescripción cargada';
                descEl.textContent = filename;
              }
              if (src) {
                thumb.src = src;
                thumb.style.display = 'block';
                viewBtnCard.style.display = 'inline-flex';
                changeBtnCard.style.display = 'inline-flex';
              } else {
                thumb.style.display = 'none';
                viewBtnCard.style.display = 'inline-flex';
                changeBtnCard.style.display = 'inline-flex';
              }
            } else {
              // No hay prescripción: restaurar descripción original y ocultar controles
              if (descEl) {
                descEl.textContent = opt.description || '';
              }
              thumb.style.display = 'none';
              viewBtnCard.style.display = 'none';
              changeBtnCard.style.display = 'none';
              try { card.classList.remove('selected'); card.removeAttribute('aria-selected'); } catch(e){}
            }
          };

          // Inicializar estado
          updateControls(existingPres);

          // Abrir overlay al pulsar (evitar que el click propague y seleccione la tarjeta accidentalmente)
          viewBtnCard.addEventListener('click', (ev) => {
            ev.stopPropagation(); ev.preventDefault();
            const pres = this.configurator && this.configurator.configuration ? this.configurator.configuration.prescription : null;
            const src = pres && (pres.url || (pres.cloudinary && pres.cloudinary.secure_url)) ? (pres.url || pres.cloudinary.secure_url) : null;
            if (src) {
              this.openPrescriptionOverlay(src);
            } else {
              this.showPrescriptionOption('photo');
            }
          });

          // Cambiar imagen: abrir el formulario de subir (no elimina la existente hasta que el usuario confirme)
          changeBtnCard.addEventListener('click', (ev) => {
            ev.stopPropagation(); ev.preventDefault();
            this.showPrescriptionOption('photo');
          });

          // Escuchar actualizaciones globales de prescripción para sincronizar el botón/miniatura
          const onUpdated = (ev) => {
            const pres = ev && ev.detail ? ev.detail.prescription : null;
            updateControls(pres);
          };
          document.addEventListener('ainy:prescription-updated', onUpdated);

          // Guardar referencia para limpieza si se destruye la tarjeta en el futuro
          card.__ainy_prescription_listener = onUpdated;
        } catch (e) {
          // no-op si algo falla mostrando controles
        }
      }

      grid.appendChild(card);
    });

    container.appendChild(grid);

    const slot = document.createElement('div');
  slot.id = 'prescription-option-slot';
  slot.className = 'prescription-slot';
  // Asegurar que arranca vacío
  slot.innerHTML = '';
  container.appendChild(slot);
  // Mostrar solo las opciones; el usuario puede seleccionar cómo insertar la graduación
  // Nota: no abrimos la opción 'manual' por defecto para evitar inyectar el formulario fallback.
  }

  attachPrescriptionListeners() {
    // Los listeners ya están en el configurador principal
    // Este método puede contener lógica específica de prescripción si es necesario
  }

  validatePrescription() {
    const fields = ['od_sphere', 'od_cylinder', 'od_axis', 'od_addition', 'os_sphere', 'os_cylinder', 'os_axis', 'os_addition'];
    let isValid = true;
    
    fields.forEach(field => {
      const input = document.querySelector(`input[name="${field}"]`);
      if (input && input.value) {
        const value = parseFloat(input.value);
        if (isNaN(value)) {
          isValid = false;
          input.classList.add('error');
        } else {
          input.classList.remove('error');
        }
      }
    });
    
    return isValid;
  }

  // Used by drawer manager to decide if we can proceed to next step
  canProceed() {
    try {
      // Check which option-card is selected
      let activeCard = document.querySelector(`#prescription-options .option-card.selected`);
      if (!activeCard) activeCard = document.querySelector(`#prescription-options .option-card[aria-selected="true"]`);
      const key = activeCard?.dataset?.key || activeCard?.dataset?.opt;

      // If photo option selected, require a recorded prescription (url or filename)
      if (key === 'photo') {
        const cfg = this.configurator && this.configurator.configuration ? this.configurator.configuration : {};
        const pres = cfg.prescription;
        if (!pres) return false;
        if (pres.url || pres.filename) return true;
        return false;
      }

      // For other options, allow proceeding (other validations live elsewhere)
      return true;
    } catch (e) {
      return false;
    }
  }

  showPrescriptionOption(key) {
    const slot = document.getElementById('prescription-option-slot');
    if (!slot) return;
    slot.innerHTML = '';

    // Clear selection UI (option-card style) and aria-selected
    document.querySelectorAll('#prescription-options .option-card').forEach(b => {
      b.classList.remove('selected');
      b.setAttribute('aria-selected', 'false');
    });
    // createOptionCard sets data-key, so buscamos por data-key; mantener compatibilidad con data-opt
    let activeCard = document.querySelector(`#prescription-options .option-card[data-key="${key}"]`);
    if (!activeCard) activeCard = document.querySelector(`#prescription-options .option-card[data-opt="${key}"]`);
    if (activeCard) {
      activeCard.classList.add('selected');
      activeCard.setAttribute('aria-selected', 'true');
    }

    if (key === 'manual') {
      // Si tenemos HTML preconstruido guardado, úsalo
      if (this._prebuiltPrescriptionHTML) {
        slot.innerHTML = this._prebuiltPrescriptionHTML;

        // Enfocar el primer input para mejorar UX
        setTimeout(() => {
          try {
            const firstInput = slot.querySelector('input, textarea, select');
            if (firstInput && typeof firstInput.focus === 'function') firstInput.focus();
          } catch (e) {}
        }, 30);

        // Attach handlers scoped to slot
        const saveBtn = slot.querySelector('#prescription-save-manual');
        if (saveBtn) {
          saveBtn.addEventListener('click', () => {
            const form = slot.querySelector('form') || slot;
            const data = {};
            ['od_sphere','od_cylinder','od_axis','od_addition','os_sphere','os_cylinder','os_axis','os_addition'].forEach(name => {
              const input = form.querySelector(`input[name="${name}"]`);
              data[name] = input && input.value ? input.value : null;
            });
            this.configurator.configuration = this.configurator.configuration || {};
            this.configurator.configuration.prescription = { method: 'manual', values: data };
            alert('Graduación guardada (manual).');
          });
        }

        const uploadBtn = slot.querySelector('#prescription-upload-photo');
        if (uploadBtn) {
          uploadBtn.addEventListener('click', () => {
            const fileInput = slot.querySelector('input[type="file"]');
            if (!fileInput || !fileInput.files || fileInput.files.length === 0) return alert('Selecciona un archivo.');
            const file = fileInput.files[0];
            this.configurator.configuration = this.configurator.configuration || {};
            this.configurator.configuration.prescription = { method: 'photo', filename: file.name };
            alert('Foto registrada: ' + file.name + '\n(Implementa subida al servidor si necesitas persistencia)');
          });
        }

        const checkExistingBtn = slot.querySelector('#prescription-check-existing');
        if (checkExistingBtn) {
          checkExistingBtn.addEventListener('click', () => {
            const emailInput = slot.querySelector('#prescription-existing-email');
            const email = emailInput && emailInput.value;
            if (!email) return alert('Introduce un email.');
            const found = email.includes('@');
            const resultDiv = slot.querySelector('#prescription-existing-result');
            if (found) {
              this.configurator.configuration = this.configurator.configuration || {};
              this.configurator.configuration.prescription = { method: 'existing', email };
              if (resultDiv) resultDiv.innerText = 'Graduación encontrada y asignada a tu pedido.';
            } else {
              if (resultDiv) resultDiv.innerText = 'No se encontró graduación para ese cliente.';
            }
          });
        }

        const sendEmailBtn = slot.querySelector('#prescription-send-email-btn');
        if (sendEmailBtn) {
          sendEmailBtn.addEventListener('click', () => {
            const emailInput = slot.querySelector('#prescription-send-email');
            const email = emailInput && emailInput.value;
            if (!email) return alert('Introduce un email válido.');
            this.configurator.configuration = this.configurator.configuration || {};
            this.configurator.configuration.prescription = { method: 'email', email };
            alert('Indicado que enviarás la prescripción por email a: ' + email);
          });
        }

      } else {
        // No hay HTML preconstruido: no inyectamos el formulario manual automáticamente.
        // Dejamos el slot vacío para que el usuario deba elegir explícitamente una opción
        // o para que otro flujo inyecte el contenido si es necesario.
        slot.innerHTML = '';
      }

    } else if (key === 'photo') {
      // Intentar inyectar la UI inline dentro del propio card seleccionado
      let activeCard = document.querySelector(`#prescription-options .option-card[data-key="${key}"]`);
      if (!activeCard) activeCard = document.querySelector(`#prescription-options .option-card[data-opt="${key}"]`);

      const injectInline = (containerEl) => {
        // Evitar duplicados
        if (containerEl.querySelector('.prescription-photo-inline')) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'prescription-photo-inline';
        wrapper.innerHTML = `
          <div class="prescription-photo-dropzone" style="margin-bottom: 20px;">
            <div class="prescription-photo-dropzone__inner" style="
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              min-height: 240px;
              padding: 40px 24px;
              border: 3px dashed #cbd5e0;
              border-radius: 8px;
              background: #fafafa;
              cursor: pointer;
              text-align: center;
              transition: all 0.3s ease;
            ">
              <div class="prescription-photo-dropzone__content">
                <div class="prescription-photo-dropzone__icon" style="
                  margin-bottom: 20px;
                  opacity: 0.6;
                  color: #718096; /* neutral icon color */
                ">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" stroke="currentColor"/>
                    <circle cx="12" cy="13" r="3" stroke="currentColor"/>
                  </svg>
                </div>
                <h3 class="prescription-photo-dropzone__title" style="
                  margin: 0 0 12px 0;
                  color: #2d3748;
                  font-size: 18px;
                  font-weight: 600;
                  line-height: 1.4;
                ">Arrastra tu prescripción aquí</h3>
                <p class="prescription-photo-dropzone__subtitle" style="
                  margin: 0 0 8px 0;
                  color: #718096;
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 1.5;
                ">o haz clic para seleccionar el archivo</p>
                <p class="prescription-photo-dropzone__formats" style="
                  margin: 0 0 24px 0;
                  color: #a0aec0;
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 1.4;
                ">Formatos: JPG, PNG (máx. 10MB)</p>
                <button type="button" class="nav-btn secondary prescription-photo-choose">
                  <span>Examinar archivos</span>
                </button>
              </div>
              <input type="file" class="prescription-photo-input visually-hidden" accept="image/*" />
            </div>
          </div>
          <div class="prescription-photo-preview" style="display:none;">
            <div class="prescription-photo-preview__content"></div>
          </div>
          <div class="prescription-photo-actions" style="display:none; flex-direction: column; gap: 0px; margin-top: 20px;">
            <button type="button" class="nav-btn secondary prescription-photo-view" style="width: 100%; justify-content: center; display: none;">
              <span>Ver imagen</span>
            </button>
            <button type="button" class="nav-btn secondary prescription-photo-remove" style="width: 100%; justify-content: center;">
              <span>Quitar imagen</span>
            </button>
            <button type="button" class="nav-btn primary prescription-photo-upload" disabled style="width: 100%; justify-content: center;">
              <span>Confirmar y continuar</span>
            </button>
          </div>
          <!-- Inline overlay viewer (muestra la imagen dentro del mismo card) -->
          <div class="prescription-photo-overlay" style="display:none; position: fixed; inset: 0; align-items: center; justify-content: center; background: rgba(0,0,0,0.6); z-index: 9999;">
            <div class="prescription-photo-overlay__inner" style="position: relative; max-width: 92%; max-height: 92%; background: #fff; padding: 12px; border-radius:8px; box-shadow: 0 8px 30px rgba(0,0,0,0.3);">
              <button type="button" class="prescription-photo-overlay__close" aria-label="Cerrar" style="position:absolute; top:8px; right:8px; background:transparent; border:none; font-size:20px; cursor:pointer;">✕</button>
              <div class="prescription-photo-overlay__content" style="max-height: calc(90vh - 60px); overflow: auto; display:flex; align-items:center; justify-content:center;">
                <img src="" alt="Prescripción" style="max-width:100%; max-height:80vh; display:block;">
              </div>
            </div>
          </div>
        `;

        containerEl.appendChild(wrapper);

        const fileInput = wrapper.querySelector('.prescription-photo-input');
        const uploadBtn = wrapper.querySelector('.prescription-photo-upload');
        const preview = wrapper.querySelector('.prescription-photo-preview');
        const previewContent = wrapper.querySelector('.prescription-photo-preview__content');
        const removeBtn = wrapper.querySelector('.prescription-photo-remove');
        const chooseBtn = wrapper.querySelector('.prescription-photo-choose');
        const dropInner = wrapper.querySelector('.prescription-photo-dropzone__inner');
        const dropzone = wrapper.querySelector('.prescription-photo-dropzone');
        const actions = wrapper.querySelector('.prescription-photo-actions');
  const viewBtn = wrapper.querySelector('.prescription-photo-view');

        // Keep track of last created object URL so we can revoke it
        let __prescriptionObjectUrl = null;

        const setFile = (file) => {
          if (!file) {
            uploadBtn.disabled = true;
            preview.style.display = 'none';
            actions.style.display = 'none';
            if (viewBtn) viewBtn.style.display = 'none';
            dropzone.style.display = 'block';
            previewContent.innerHTML = '';
            return;
          }
          uploadBtn.disabled = false;
          preview.style.display = 'block';
          actions.style.display = 'flex';
          if (viewBtn) viewBtn.style.display = 'block';
          // Ensure buttons are block and full width and add explicit spacing
          try {
            removeBtn.style.display = 'block';
            removeBtn.style.width = '100%';
            removeBtn.style.marginBottom = '16px';
            uploadBtn.style.display = 'block';
            uploadBtn.style.width = '100%';
          } catch (e) {}
          dropzone.style.display = 'none';
          try {
            // Revoke previous url if exists
            try { if (__prescriptionObjectUrl) URL.revokeObjectURL(__prescriptionObjectUrl); } catch(e){}
            __prescriptionObjectUrl = URL.createObjectURL(file);
            previewContent.innerHTML = `<div class="prescription-photo-preview__wrap"><img src="${__prescriptionObjectUrl}" alt="Vista previa de la prescripción"/></div>`;
            // Also set the overlay image src if already present in DOM
            const overlay = wrapper.querySelector('.prescription-photo-overlay');
            if (overlay) {
              const overlayImg = overlay.querySelector('.prescription-photo-overlay__content img');
              if (overlayImg) overlayImg.src = __prescriptionObjectUrl;
            }
          } catch (e) { 
            previewContent.innerHTML = '<p>Error al mostrar la vista previa</p>'; 
          }
        };

        // File input change
        fileInput.addEventListener('change', () => {
          const files = fileInput.files;
          if (!files || files.length === 0) { 
            setFile(null); 
            return; 
          }
          setFile(files[0]);
        });

        // Choose button opens file picker
        chooseBtn.addEventListener('click', () => fileInput.click());

        // Hover effects
        dropInner.addEventListener('mouseenter', () => {
          dropInner.style.borderColor = '#667eea';
          dropInner.style.background = '#f7fafc';
          dropInner.style.boxShadow = '0 4px 20px rgba(102, 126, 234, 0.15)';
          dropInner.style.transform = 'translateY(-1px)';
        });

        dropInner.addEventListener('mouseleave', () => {
          if (!dropInner.classList.contains('is-dragover')) {
            dropInner.style.borderColor = '#cbd5e0';
            dropInner.style.background = '#fafafa';
            dropInner.style.boxShadow = 'none';
            dropInner.style.transform = 'none';
          }
        });

        // Drag & Drop handlers
        ['dragenter', 'dragover'].forEach(evt => {
          dropInner.addEventListener(evt, (e) => { 
            e.preventDefault(); 
            e.stopPropagation(); 
            dropInner.classList.add('is-dragover');
            dropInner.style.borderColor = '#4299e1';
            dropInner.style.borderStyle = 'solid';
            dropInner.style.background = '#ebf8ff';
            dropInner.style.boxShadow = '0 8px 30px rgba(66, 153, 225, 0.25)';
            dropInner.style.transform = 'scale(1.01)';
          }, false);
        });
        
        ['dragleave', 'drop'].forEach(evt => {
          dropInner.addEventListener(evt, (e) => { 
            e.preventDefault(); 
            e.stopPropagation(); 
            dropInner.classList.remove('is-dragover');
            dropInner.style.borderColor = '#cbd5e0';
            dropInner.style.borderStyle = 'dashed';
            dropInner.style.background = '#fafafa';
            dropInner.style.boxShadow = 'none';
            dropInner.style.transform = 'none';
          }, false);
        });

        dropInner.addEventListener('drop', (e) => {
          const dt = e.dataTransfer;
          if (!dt || !dt.files || dt.files.length === 0) return;
          const file = dt.files[0];
          // assign to input (for consistency)
          try {
            // Some browsers allow setting files via DataTransfer
            fileInput.files = dt.files;
          } catch (err) {
            // fallback: create a new FileList is not trivial; we'll just handle file directly
          }
          setFile(file);
        });

        // Remove file: revoke any created object URL and reset UI
        removeBtn.addEventListener('click', () => {
          try { fileInput.value = ''; } catch (e) {}
          try { if (__prescriptionObjectUrl) { URL.revokeObjectURL(__prescriptionObjectUrl); __prescriptionObjectUrl = null; } } catch(e){}
          // Close overlay if open
          const overlay = wrapper.querySelector('.prescription-photo-overlay');
          if (overlay && overlay.style.display !== 'none') {
            overlay.style.display = 'none';
          }
          setFile(null);
          // Notify other UI parts that the prescription was removed
          try {
            this.configurator.configuration = this.configurator.configuration || {};
            delete this.configurator.configuration.prescription;
            document.dispatchEvent(new CustomEvent('ainy:prescription-updated', { detail: { prescription: null } }));
          } catch (e) {}
        });

        // View image: open inline overlay inside the same card
        if (viewBtn) {
          viewBtn.addEventListener('click', () => {
            try {
              const overlay = wrapper.querySelector('.prescription-photo-overlay');
              if (!overlay) return alert('No hay visor disponible.');
              const overlayImg = overlay.querySelector('.prescription-photo-overlay__content img');
              // Prefer the preview image src
              const img = previewContent.querySelector('img');
              const src = img?.src || this.configurator?.configuration?.prescription?.url || null;
              if (src) {
                overlayImg.src = src;
                overlay.style.display = 'flex';
                // prevent background scroll
                try { document.body.style.overflow = 'hidden'; } catch(e){}
              } else {
                alert('No hay imagen disponible para ver.');
              }
            } catch (e) {
              console.error('Failed to open inline viewer', e);
              alert('No se pudo abrir la imagen.');
            }
          });
        }

        // Overlay close button
        const overlay = wrapper.querySelector('.prescription-photo-overlay');
        if (overlay) {
          const closeBtn = overlay.querySelector('.prescription-photo-overlay__close');
          closeBtn.addEventListener('click', () => {
            try { overlay.style.display = 'none'; document.body.style.overflow = ''; } catch(e){}
          });
          // Also close when clicking on backdrop
          overlay.addEventListener('click', (ev) => {
            if (ev.target === overlay) {
              try { overlay.style.display = 'none'; document.body.style.overflow = ''; } catch(e){}
            }
          });
        }

        // Upload (register locally; optional: post to server via Cloudinary fallback endpoint)
        uploadBtn.addEventListener('click', async () => {
          const files = fileInput.files;
          if (!files || files.length === 0) return alert('Selecciona un archivo.');
          const file = files[0];
          
          // Validate file before upload
          const maxSize = 10 * 1024 * 1024; // 10MB
          if (file.size > maxSize) {
            return alert('El archivo es demasiado grande. Máximo 10MB permitido.');
          }
          
          const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
          if (!allowedTypes.includes(file.type)) {
            return alert('Formato no válido. Solo se permiten: JPEG, PNG, WebP');
          }
          
          this.configurator.configuration = this.configurator.configuration || {};

          // Prefer Cloudinary unsigned upload if configured, otherwise fall back to a generic upload endpoint.
          const fallbackUrl = window.CLOUDINARY_FALLBACK_UPLOAD_URL || window.CLOUDINARY_FALLBACK_UPLOAD_ENDPOINT || window.CLOUDINARY_UPLOAD_URL || window.CLOUDINARY_UPLOAD_ENDPOINT;
          // Allow quick local defaults for Cloudinary; prefer values injected by the theme or snippet.
          // Warning: do not hard-code secrets in repo. These defaults are only used if the page doesn't provide them.
          if (!window.CLOUDINARY_UPLOAD_PRESET && typeof window !== 'undefined') {
            // The user provided an upload preset and a sample public id. We set the preset so client uploads work if not otherwise configured.
            window.CLOUDINARY_UPLOAD_PRESET = window.CLOUDINARY_UPLOAD_PRESET || 'AinyMore';
          }
          
          // Force correct cloud name if placeholder is detected
          if (!window.CLOUDINARY_CLOUD_NAME || 
              window.CLOUDINARY_CLOUD_NAME === 'demo' || 
              window.CLOUDINARY_CLOUD_NAME === 'your-cloud-name' || 
              window.CLOUDINARY_CLOUD_NAME === 'your_cloud_name') {
            
            console.warn('⚠️ Detected placeholder cloud name, using hardcoded fallback');
            window.CLOUDINARY_CLOUD_NAME = 'djgpadfgu'; // Force correct cloud name
          }
          
          // Validate Cloudinary configuration
          console.log('🔍 Pre-validation Cloud Name:', window.CLOUDINARY_CLOUD_NAME);
          console.log('🔍 Pre-validation Upload Preset:', window.CLOUDINARY_UPLOAD_PRESET);
          
          if (!window.CLOUDINARY_CLOUD_NAME || window.CLOUDINARY_CLOUD_NAME === 'demo' || window.CLOUDINARY_CLOUD_NAME === 'your-cloud-name') {
            console.warn('⚠️ CLOUDINARY_CLOUD_NAME no configurado correctamente:', window.CLOUDINARY_CLOUD_NAME);
            return alert('Error de configuración: Cloud name no válido (' + window.CLOUDINARY_CLOUD_NAME + '). Contacta al administrador.');
          }
          
          if (!window.CLOUDINARY_UPLOAD_PRESET) {
            console.warn('⚠️ CLOUDINARY_UPLOAD_PRESET no configurado');
            return alert('Error de configuración: Upload preset no configurado. Contacta al administrador.');
          }
          
          const cloudinaryUrl = window.CLOUDINARY_UPLOAD_URL || `https://api.cloudinary.com/v1_1/${window.CLOUDINARY_CLOUD_NAME}/auto/upload`;
          
          console.log('🔍 Final Cloudinary URL será:', cloudinaryUrl);          if (cloudinaryUrl && window.CLOUDINARY_UPLOAD_PRESET) {
            try {
              uploadBtn.disabled = true;
              uploadBtn.textContent = 'Subiendo…';
              
              // Debug: Log configuration
              console.log('🔧 Cloudinary Upload Debug:', {
                cloudName: window.CLOUDINARY_CLOUD_NAME,
                uploadPreset: window.CLOUDINARY_UPLOAD_PRESET,
                uploadUrl: cloudinaryUrl,
                fileSize: file.size,
                fileName: file.name,
                fileType: file.type
              });
              
              const form = new FormData();
              form.append('file', file);
              // unsigned preset required for direct client uploads
              form.append('upload_preset', window.CLOUDINARY_UPLOAD_PRESET);
              // optional: allow user to set folder/tags via window variables
              if (window.CLOUDINARY_FOLDER) form.append('folder', window.CLOUDINARY_FOLDER);
              if (window.CLOUDINARY_TAGS) form.append('tags', window.CLOUDINARY_TAGS);

              const resp = await fetch(cloudinaryUrl, { method: 'POST', body: form });
              
              // Enhanced error handling
              if (!resp.ok) {
                let errorMessage = `Upload failed: ${resp.status}`;
                try {
                  const errorData = await resp.json();
                  console.error('❌ Cloudinary Error Response:', errorData);
                  if (errorData.error && errorData.error.message) {
                    errorMessage += ` - ${errorData.error.message}`;
                  }
                } catch (e) {
                  console.error('❌ Failed to parse error response:', e);
                }
                throw new Error(errorMessage);
              }
              
              const json = await resp.json();
              console.log('✅ Cloudinary Upload Success:', json);
              const fileUrl = json.secure_url || json.url || '';
              // store extra Cloudinary metadata if available
              this.configurator.configuration.prescription = {
                method: 'photo',
                filename: file.name,
                url: fileUrl,
                cloudinary: {
                  public_id: json.public_id,
                  version: json.version,
                  width: json.width,
                  height: json.height,
                }
              };
              
              // ✅ OPCIÓN A: Persistir inmediatamente después de subida exitosa
              const persisted = await this.persistPrescriptionToShopify(this.configurator.configuration.prescription);
              // Informar a otros componentes de la nueva prescripción
              document.dispatchEvent(new CustomEvent('ainy:prescription-updated', { detail: { prescription: this.configurator.configuration.prescription, persisted } }));
              
            } catch (err) {
              console.error('Cloudinary upload error', err);
              
              // Provide user-friendly error messages
              let userMessage = 'Error subiendo el archivo a Cloudinary';
              
              if (err.message.includes('400')) {
                userMessage = '❌ Error de configuración de Cloudinary. Posibles causas:\n\n' +
                            '• Upload preset "AinyMore" no existe o no está configurado como unsigned\n' +
                            '• Cloud name incorrecto\n' +
                            '• Formato de archivo no permitido en el preset\n\n' +
                            'Contacta al administrador para revisar la configuración.';
              } else if (err.message.includes('413')) {
                userMessage = '❌ Archivo demasiado grande. Reduce el tamaño de la imagen e inténtalo de nuevo.';
              } else if (err.message.includes('415')) {
                userMessage = '❌ Formato de archivo no soportado. Usa JPG, PNG o WebP.';
              } else if (err.message.includes('401')) {
                userMessage = '❌ Error de autenticación. Upload preset no autorizado.';
              } else if (err.message.includes('Network')) {
                userMessage = '❌ Error de conexión. Verifica tu internet e inténtalo de nuevo.';
              }
              
              alert(userMessage);
              uploadBtn.disabled = false;
              uploadBtn.textContent = 'Confirmar y continuar';
              return;
            }
          } else if (fallbackUrl) {
            try {
              uploadBtn.disabled = true;
              uploadBtn.textContent = 'Subiendo…';
              const form = new FormData();
              form.append('file', file);
              const headers = {};
              if (window.CLOUDINARY_FALLBACK_API_KEY) headers['Authorization'] = `Bearer ${window.CLOUDINARY_FALLBACK_API_KEY}`;
              const resp = await fetch(fallbackUrl, { method: 'POST', body: form, headers });
              if (!resp.ok) throw new Error(`Upload failed: ${resp.status}`);
              const json = await resp.json();
              const fileUrl = json.url || json.secure_url || json.fileUrl || json.data?.url || '';
              this.configurator.configuration.prescription = { method: 'photo', filename: file.name, url: fileUrl };
              
              // ✅ OPCIÓN A: Persistir inmediatamente después de subida exitosa (fallback endpoint)
              const persisted = await this.persistPrescriptionToShopify(this.configurator.configuration.prescription);
              document.dispatchEvent(new CustomEvent('ainy:prescription-updated', { detail: { prescription: this.configurator.configuration.prescription, persisted } }));
              
            } catch (err) {
              console.error('Upload error', err);
              alert('Error subiendo el archivo: ' + (err && err.message ? err.message : String(err)));
              uploadBtn.disabled = false;
              uploadBtn.textContent = 'Confirmar y continuar';
              return;
            }
          } else {
            // No cloud endpoint: register filename locally (non-persistent)
            this.configurator.configuration.prescription = { method: 'photo', filename: file.name };
          }

          try { containerEl.classList.add('selected'); containerEl.setAttribute('aria-selected', 'true'); } catch (e) {}

          // Advance to next step now that we have a prescription recorded
          try {
            if (this.configurator && typeof this.configurator.nextStep === 'function') {
              this.configurator.nextStep();
              return;
            }
          } catch (e) {
            // fallback: continue
          }

          alert('Foto registrada: ' + file.name + '\n(Se ha registrado localmente).');
        });
      };

        // If there's a previously restored prescription, populate the preview using the stored URL/filename
        try {
          const existingPres = this.configurator?.configuration?.prescription;
          if (existingPres && existingPres.method === 'photo' && (existingPres.url || existingPres.filename)) {
            // show preview area with either image (if URL) or filename
            try {
              uploadBtn.disabled = false;
              preview.style.display = 'block';
              actions.style.display = 'flex';
              dropzone.style.display = 'none';
              removeBtn.style.display = 'block';
              removeBtn.style.width = '100%';
              removeBtn.style.marginBottom = '16px';
              uploadBtn.style.display = 'block';
              uploadBtn.style.width = '100%';

              const imageUrl = existingPres.url || (existingPres.cloudinary && existingPres.cloudinary.secure_url) || null;
              if (imageUrl) {
                previewContent.innerHTML = `<div class="prescription-photo-preview__wrap"><img src="${imageUrl}" alt="Prescripción guardada"/></div>`;
              } else {
                previewContent.innerHTML = `<div class="prescription-photo-preview__wrap"><div style="padding:12px">${existingPres.filename}</div></div>`;
              }

              // Mark card as selected visually
              try { containerEl.classList.add('selected'); containerEl.setAttribute('aria-selected', 'true'); } catch (e) {}
            } catch (e) {
              console.warn('Failed to populate preview from restored prescription', e);
            }
          }
        } catch (e) {}

      if (activeCard) {
        injectInline(activeCard);
      } else {
        // Fallback: inyectar en el slot como antes
        slot.innerHTML = `
          <div class="prescription-photo">
            <p>Sube una foto de tu prescripción (JPEG/PNG).</p>
            <input type="file" id="prescription-photo-file" accept="image/*" />
            <div style="margin-top:10px;"><button type="button" id="prescription-upload-photo">Subir foto</button></div>
          </div>
        `;

        document.getElementById('prescription-upload-photo').addEventListener('click', async () => {
          const fileInput = document.getElementById('prescription-photo-file');
          if (!fileInput.files || fileInput.files.length === 0) return alert('Selecciona un archivo.');
          const file = fileInput.files[0];

          this.configurator.configuration = this.configurator.configuration || {};
          this.configurator.configuration.prescription = { method: 'photo', filename: file.name };
          alert('Foto registrada: ' + file.name + '\n(Implementa subida al servidor si necesitas persistencia)');
        });
      }

    } else if (key === 'existing') {
      slot.innerHTML = ``;

      document.getElementById('prescription-check-existing').addEventListener('click', async () => {
        const email = document.getElementById('prescription-existing-email').value;
        if (!email) return alert('Introduce un email.');

        // Lógica real aquí: consultar API de clientes. Por ahora simulamos éxito si contiene '@'
        const found = email.includes('@');
        const resultDiv = document.getElementById('prescription-existing-result');
        if (found) {
          this.configurator.configuration = this.configurator.configuration || {};
          this.configurator.configuration.prescription = { method: 'existing', email };
          resultDiv.innerText = 'Graduación encontrada y asignada a tu pedido.';
        } else {
          resultDiv.innerText = 'No se encontró graduación para ese cliente.';
        }
      });

    } else if (key === 'email') {
      slot.innerHTML = ``;

      document.getElementById('prescription-send-email-btn').addEventListener('click', () => {
        const email = document.getElementById('prescription-send-email').value;
        if (!email) return alert('Introduce un email válido.');
        this.configurator.configuration = this.configurator.configuration || {};
        this.configurator.configuration.prescription = { method: 'email', email };
        alert('Indicado que enviarás la prescripción por email a: ' + email);
      });
    }
  }

  /**
   * � Recuperación automática de prescripciones guardadas
   * Intenta restaurar una prescripción previamente guardada
   */
  tryRestorePreviousPrescription() {
    try {
      // Prioridad 1: sessionStorage (sesión actual)
      const sessionData = sessionStorage.getItem('ainy_prescription_session');
      if (sessionData) {
        const prescription = JSON.parse(sessionData);
        if (this.isValidPrescriptionData(prescription)) {
          this.restorePrescription(prescription, 'session');
          return;
        }
      }

      // Prioridad 2: localStorage (prescripción actual)
      const currentData = localStorage.getItem('ainy_prescription_current');
      if (currentData) {
        const prescription = JSON.parse(currentData);
        if (this.isValidPrescriptionData(prescription)) {
          this.restorePrescription(prescription, 'localStorage');
          return;
        }
      }

      // Prioridad 3: cart attributes (si hay carrito)
      this.tryRestoreFromCartAttributes();

    } catch (error) {
      console.warn('Failed to restore previous prescription:', error);
    }
  }

  /**
   * Validar que los datos de prescripción son válidos
   */
  isValidPrescriptionData(prescription) {
    return prescription && 
           prescription.method === 'photo' && 
           prescription.url && 
           prescription.filename &&
           // Verificar que no sea muy antigua (24 horas)
           (!prescription.timestamp || (Date.now() - new Date(prescription.timestamp).getTime()) < 24 * 60 * 60 * 1000);
  }

  /**
   * Restaurar prescripción en el configurador
   */
  restorePrescription(prescription, source) {
    console.log(`🔄 Restoring prescription from ${source}:`, prescription);
    
    // Actualizar configuración del configurador
    this.configurator.configuration = this.configurator.configuration || {};
    this.configurator.configuration.prescription = prescription;

    // Mostrar notificación al usuario
    this.showRestoredPrescriptionNotification(prescription, source);
    // Notificar al resto de la UI para que actualice miniaturas/botones
    try {
      document.dispatchEvent(new CustomEvent('ainy:prescription-updated', { detail: { prescription } }));
    } catch (e) {}
  }

  /**
   * Intentar recuperar desde cart attributes
   */
  async tryRestoreFromCartAttributes() {
    try {
      const response = await fetch('/cart.js');
      if (response.ok) {
        const cart = await response.json();
        const prescriptionData = cart.attributes['_prescription_data'];
        if (prescriptionData) {
          const prescription = JSON.parse(prescriptionData);
          if (this.isValidPrescriptionData(prescription)) {
            this.restorePrescription(prescription, 'cart');
          }
        }
      }
    } catch (error) {
      console.warn('Failed to restore from cart attributes:', error);
    }
  }

  /**
   * Mostrar notificación de prescripción restaurada
   */
  showRestoredPrescriptionNotification(prescription, source) {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #28a745;
      color: white;
      padding: 12px 20px;
      border-radius: 6px;
      font-size: 14px;
      z-index: 10000;
      max-width: 300px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    `;
    
    notification.innerHTML = `
      <div style="font-weight: bold; margin-bottom: 4px;">✅ Prescripción Restaurada</div>
      <div style="font-size: 12px; opacity: 0.9;">
        ${prescription.filename} desde ${source === 'session' ? 'sesión actual' : source === 'localStorage' ? 'almacén local' : 'carrito'}
      </div>
    `;

    document.body.appendChild(notification);

    // Auto-remover después de 5 segundos
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 5000);
  }

  /**
   * �🚀 OPCIÓN A: Persistencia automática al subir imagen
   * Guarda la prescripción inmediatamente en Shopify usando múltiples estrategias
   */
  async persistPrescriptionToShopify(prescriptionData) {
    const timestamp = new Date().toISOString();
    const sessionId = this.getOrCreateSessionId();
    
    const prescriptionPayload = {
      ...prescriptionData,
      timestamp: timestamp,
      sessionId: sessionId,
      step: 'prescription',
      source: 'lens-configurator'
    };

    const strategies = [
      () => this.addToCartAttributes(prescriptionPayload),
      () => this.saveToLocalStorage(prescriptionPayload), 
      () => this.saveToSessionStorage(prescriptionPayload)
    ];

    let successCount = 0;
    const errors = [];

    for (const strategy of strategies) {
      try {
        await strategy();
        successCount++;
      } catch (error) {
        console.warn('Prescription persistence strategy failed:', error);
        errors.push(error.message || String(error));
      }
    }

    if (successCount === 0) {
      throw new Error(`All persistence strategies failed: ${errors.join(', ')}`);
    }

    console.log(`✅ Prescription persisted successfully using ${successCount}/${strategies.length} strategies`);
    return prescriptionPayload;
  }

  /**
   * Estrategia 1: Añadir a cart attributes (principal)
   */
  async addToCartAttributes(prescriptionData) {
    try {
      // Actualizar cart attributes via Shopify Cart API
      const cartUpdate = {
        attributes: {
          '_prescription_uploaded': 'true',
          '_prescription_url': prescriptionData.url || '',
          '_prescription_filename': prescriptionData.filename || '',
          '_prescription_method': prescriptionData.method || '',
          '_prescription_timestamp': prescriptionData.timestamp,
          '_prescription_session': prescriptionData.sessionId,
          '_prescription_data': JSON.stringify(prescriptionData)
        }
      };

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartUpdate)
      });

      if (!response.ok) {
        throw new Error(`Cart update failed: ${response.status}`);
      }

      const result = await response.json();
      console.log('✅ Cart attributes updated:', result.attributes);
      
      // Disparar evento de actualización del carrito
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { prescriptionAdded: true, prescription: prescriptionData }
      }));

      return result;
    } catch (error) {
      console.error('Failed to add prescription to cart attributes:', error);
      throw error;
    }
  }

  /**
   * Estrategia 2: Guardar en localStorage (fallback persistente)
   */
  async saveToLocalStorage(prescriptionData) {
    try {
      const storageKey = 'ainy_prescription_backup';
      const existingData = JSON.parse(localStorage.getItem(storageKey) || '[]');
      
      // Mantener solo las últimas 5 prescripciones por performance
      const updatedData = [prescriptionData, ...existingData].slice(0, 5);
      
      localStorage.setItem(storageKey, JSON.stringify(updatedData));
      localStorage.setItem('ainy_prescription_current', JSON.stringify(prescriptionData));
      
      console.log('✅ Prescription saved to localStorage');
      return true;
    } catch (error) {
      console.error('Failed to save prescription to localStorage:', error);
      throw error;
    }
  }

  /**
   * Estrategia 3: Guardar en sessionStorage (temporal)
   */
  async saveToSessionStorage(prescriptionData) {
    try {
      sessionStorage.setItem('ainy_prescription_session', JSON.stringify(prescriptionData));
      console.log('✅ Prescription saved to sessionStorage');
      return true;
    } catch (error) {
      console.error('Failed to save prescription to sessionStorage:', error);
      throw error;
    }
  }

  /**
   * Generar o recuperar session ID único para tracking
   */
  getOrCreateSessionId() {
    let sessionId = sessionStorage.getItem('ainy_session_id');
    if (!sessionId) {
      sessionId = 'sess_' + Date.now().toString(36) + '_' + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem('ainy_session_id', sessionId);
    }
    return sessionId;
  }
}

// Hacer disponible globalmente
window.PrescriptionStep = PrescriptionStep;

// 🔧 Función de diagnóstico para Cloudinary
window.debugCloudinaryConfig = function() {
  console.log('🔧 === CLOUDINARY CONFIGURATION DEBUG ===');
  console.log('Cloud Name:', window.CLOUDINARY_CLOUD_NAME);
  console.log('Upload Preset:', window.CLOUDINARY_UPLOAD_PRESET);
  console.log('Folder:', window.CLOUDINARY_FOLDER);
  console.log('Tags:', window.CLOUDINARY_TAGS);
  
  const expectedUrl = window.CLOUDINARY_CLOUD_NAME ? 
    `https://api.cloudinary.com/v1_1/${window.CLOUDINARY_CLOUD_NAME}/auto/upload` : 'undefined';
  console.log('Expected Upload URL:', expectedUrl);
  
  // Test basic connectivity
  if (window.CLOUDINARY_CLOUD_NAME && window.CLOUDINARY_CLOUD_NAME !== 'demo') {
    console.log('🧪 Testing connectivity...');
    fetch(`https://api.cloudinary.com/v1_1/${window.CLOUDINARY_CLOUD_NAME}/auto/upload`, {
      method: 'POST',
      body: new FormData()
    }).then(response => {
      console.log('📡 Connectivity test response status:', response.status);
      if (response.status === 400) {
        console.log('✅ Cloudinary endpoint is reachable (400 expected for empty request)');
      }
    }).catch(error => {
      console.error('❌ Connectivity test failed:', error);
    });
  }
  
  console.log('===========================================');
  console.log('💡 Si ves errores 400, verifica en Cloudinary Dashboard:');
  console.log('1. Settings → Upload presets');
  console.log('2. Busca el preset "AinyMore"');
  console.log('3. Debe estar configurado como "Unsigned"');
  console.log('4. Cloud name debe coincidir exactamente');
};

console.log('💡 Ejecuta debugCloudinaryConfig() en la consola para diagnosticar problemas');

// dev-hot-reload-test: 2025-09-30 09:10:00 — prueba para confirmar full-page reload

/*
Snippet (paste into theme.liquid inside <head> or a safe snippet) to set Cloudinary vars globally:

<script>
  window.CLOUDINARY_CLOUD_NAME = 'djgpadfgu'; // required for direct URL generation
  window.CLOUDINARY_UPLOAD_PRESET = 'AinyMore'; // provided upload preset (you indicated)
  // Optional: fallback endpoint if you have your own upload proxy
  // window.CLOUDINARY_FALLBACK_UPLOAD_URL = 'https://mi-api.example.com/upload';
</script>

Notes:
- You told me the Cloudinary public id (PID) is c30bea91-cf81-43e9-9d88-0398c632573d and the upload preset is 'AinyMore'.
- The code will use the upload preset to perform unsigned uploads directly to Cloudinary if the cloud name is present.
- Do not commit secrets (API keys) into the repo. For signed uploads, implement a server-side signature endpoint and we can wire it in.
*/